import React, { useState } from 'react';
import './Carousel.css';
import bookingImg from "../../Images/ganesh.jpg";
import restaurantImg from "../../Images/restaurantImage.jpg";
import restaurantLight from "../../Images/restaurantLight.jpg";
import restaurantBench from "../../Images/restaurantBench.jpg";
import hallway from "../../Images/hallway.jpg";

const Carousel = () => {
  const images = [
    restaurantImg,
    restaurantLight,
    restaurantBench,
    hallway,
    bookingImg
  ];
  const [activeIndex, setActiveIndex] = useState(0);
  const [fade, setFade] = useState(false);
  const nextSlide = () => {
    setFade(true);
    setTimeout(()=>{
      setActiveIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
      setFade(false);
    }, 300);
  };
  const prevSlide = () => {
    setFade(true);
    setTimeout(()=>{
      setActiveIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
      setFade(false);
    }, 300);
  };
  return (
    <div className="carousel">
      <button onClick={prevSlide} className="carousel__btn carousel__btn--prev">
        &lt;
      </button>
      <img
        src={images[activeIndex]}
        alt={`Slide ${activeIndex}`}
        className={`carousel__img ${fade ? 'fade-out' : 'fade-in'}`}
      />
      <button onClick={nextSlide} className="carousel__btn carousel__btn--next">
        &gt;
      </button>
    </div>
  );
};
export default Carousel;
